import { render, staticRenderFns } from "./systemIntroduction.vue?vue&type=template&id=230394fc&scoped=true&"
import script from "./systemIntroduction.vue?vue&type=script&lang=js&"
export * from "./systemIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./systemIntroduction.vue?vue&type=style&index=0&id=230394fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230394fc",
  null
  
)

export default component.exports